import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-quick-reaction-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './quick-reaction-menu.component.html',
  styleUrls: ['./quick-reaction-menu.component.css'],
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class QuickReactionMenuComponent {
  @Input() commonReactions: string[] = ['👍', '❤️', '😂', '😮', '🙏'];
  @Output() reactionSelected = new EventEmitter<string>();
  @Output() openPicker = new EventEmitter<void>();

  onReactionSelect(emoji: string) {
    this.reactionSelected.emit(emoji);
  }

  onOpenPicker() {
    this.openPicker.emit();
  }
}
